import { Component, OnInit } from '@angular/core';
import { AppFilter } from 'src/modules/shared/';
import { environment } from 'src/environments/environment';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
} from '@richardlt/ng2-semantic-ui';

interface IViewCompanyDetailsModalContext {
  title: String;
  details: any;
  watcher: any;
  participant: any;
}

@Component({
  selector: 'app-view-company-details-modal',
  templateUrl: './view-company-details-modal.component.html',
  styleUrls: ['./view-company-details-modal.component.scss'],
})
export class ViewCompanyDetailsModalComponent implements OnInit {
  baseUrl = environment.API_SERVER;
  activeTab: number = 1;
  pending: boolean;
  success: any;
  error: any;
  filter: AppFilter = new AppFilter();

  data;
  assignedTopics: any[] = [];
  changeTab(tab: number) {
    this.activeTab = tab;
  }
  watchers;
  participants;
  loadImage(imagePath: any) {
    return imagePath
      ? `${this.baseUrl}/public/image/?media=${imagePath.replace(/\\/g, '/')}`
      : 'assets/avatar/1.jpg';
  }
  constructor(
    public modal: SuiModal<IViewCompanyDetailsModalContext, void, void>
  ) {
    this.data = modal.context.details;
    this.watchers = modal.context.watcher;
    this.participants = modal.context.participant;
    if (this.modal.context.title == 'View More Details') {
      let arr: any[] = [];
      this.modal.context.details.assignedTopics.map((item, index) => {
        if (item.session) {
          if (item.session.subtopic != null) {
            arr.push(item.session.subtopic.topic.topic);
          } else {
            arr.push('deleted data');
          }
        } else {
          arr.push(item.subtopic.topic.topic);
        }
      });
      console.log(arr);

      this.assignedTopics = Array.from(new Set(arr));
    }
  }

  ngOnInit() {}

  dataToJSON(data: any) {
    try {
      const jsonData = JSON.parse(data);
      return jsonData;
    } catch (error) {
      return null; // or handle the error in another way
    }
  }
}

export class ViewCompanyDetailsModal extends ComponentModalConfig<
  IViewCompanyDetailsModalContext,
  void,
  void
> {
  constructor(
    title: String,
    details: any,
    watcher: any,
    participant: any,
    size: ModalSize = ModalSize.Mini
  ) {
    super(ViewCompanyDetailsModalComponent, {
      title: title,
      details: details,
      watcher: watcher,
      participant: participant,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
